// extracted by mini-css-extract-plugin
export default {"content":"main_content__FC76M"};